import { Selection } from './../../components/FiltersProvider/types';

export const filtersToGraph = (selection: Selection): string => {
	const filters: string[] = [];
	const filtersKeys = Object.keys(selection);

	filtersKeys.forEach((filter) => {
		if (selection[filter].length === 0) return;

		filters.push(`${filter}:${selection[filter].join(',')}`);
	});

	return filters.length === 0 ? '' : filters.join('|');
};
